// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"baebda5a","491":"1372f98e","907":"8ef19b41","956":"e2528ad4"}[chunkId] + ".css";
};